import React, { useContext } from 'react';
import {useTranslation} from "react-i18next";
import device from "current-device";
import {ScrollToPosition} from "../../utils/ScrollToPosition";
import {PopupContext} from "../../App";
import {observer} from "mobx-react-lite";

const LotteryBox = ({game}) => {
    const {t} = useTranslation();
    const [, setPopupContext] = useContext(PopupContext);

    const handlePopup = (e) => {
        if (!device.mobile()) {
            e.preventDefault();
            ScrollToPosition(false, window.pageYOffset);
            setPopupContext(e.target.closest('a').href)
        }
    };

    return (
        <div className={`box ${game.top_game ? 'top' : ''} ${game.game_new ? 'new' : ''}`}>
            {game.top_game ? <div className="top"><span>{t('Топ')}</span></div> : null}
            {game.game_new ? <div className="new"><span>{t('Новинка')}</span></div> : null}
            <div className="box_img">
                <img src={game.image} alt={game.name} />
            </div>
            <div className="box_title">
                <h1>{game.name}</h1>
                <div className="key">
                    <span>ID</span>
                    <span className="number">{game.game_id}</span>
                </div>
            </div>
            <div className="box_inf">
                {game.game_type === 'scratchcards' ? <div className="type">
                    <span>{`${t('Тип')}: `}</span>
                    <span className="inf">
                        {t('Скретч-карти')}
                    </span>
                </div> : null}
                <div className="free">
                    <span>{`${t('Безкоштовні ігри')}: `}</span>
                    <span className="inf">
                        {game.free_game ? t('Так') : t('Ні')}
                    </span>
                </div>
                <div className="reels">
                    <span>{`${t('Барабани')}: `}</span>
                    <span className="inf">{game.game_reels === 0 ? t('Ні') : game.game_reels}</span>
                </div>
            </div>
            <div className="box_button">
                <a
                    onClick={handlePopup}
                    href={game.play_game_url}
                >{t('Грати')}</a>
            </div>
        </div>
    );
};

export default observer(LotteryBox);